export default __webpack_public_path__ + "denis@2x.987a8f76.jpg";